// HubSpot option colors are often pale, so always-white text is unreadable — choose ink by luminance (YIQ).
export function readableInk(hexColor: string): string {
	const hex = hexColor.replace('#', '');
	if (hex.length !== 6) return 'var(--attr-ink)';
	const r = Number.parseInt(hex.slice(0, 2), 16);
	const g = Number.parseInt(hex.slice(2, 4), 16);
	const b = Number.parseInt(hex.slice(4, 6), 16);
	if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return 'var(--attr-ink)';
	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 150 ? 'var(--attr-ink)' : 'var(--call-ink)';
}
